module.exports = __webpack_public_path__ + "static/emerge_screen.67578a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emerge_screen.png
// module id = 3095
// module chunks = 213231404188204